import { render, staticRenderFns } from "./gather.vue?vue&type=template&id=28b29179&scoped=true&"
import script from "./gather.vue?vue&type=script&lang=js&"
export * from "./gather.vue?vue&type=script&lang=js&"
import style0 from "./gather.vue?vue&type=style&index=0&id=28b29179&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b29179",
  null
  
)

export default component.exports